/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import React, { ReactElement } from "react";

import approved from "Assets/Icons/Status/approved.png";
import denied from "Assets/Icons/Status/denied.png";
import saved from "Assets/Icons/Status/saved.png";
import submitted from "Assets/Icons/Status/submitted.png";
import underReview from "Assets/Icons/Status/under-review.png";
import waiting from "Assets/Icons/Status/waiting.png";
import { accessControlUserStatusTypes } from "Constants/AccessControlConstants";
import { ApplicationStatusTypesEnum } from "Constants/ApplicationStatusTypes";
import { BenefitStatusEnum } from "Constants/BenefitConstants";
import { eventStatusTypes } from "Constants/EventConstants";
import { programStatusTypes } from "Constants/ProfileConstants";
import { VisualStudioBenefitStatusEnum } from "Constants/VisualStudioBenefitConstants";

import IStatusElementProps from "./IStatusElementProps";
import { StatusImg, StatusSpan } from "./StatusElement.styles";

const getImgSource = (statusValue: string): string => {
  let imgSource = "";
  switch (statusValue) {
    case eventStatusTypes.APPROVED:
    case accessControlUserStatusTypes.ACTIVE:
    case programStatusTypes.ACTIVE_VENDOR:
    case BenefitStatusEnum.Claimed:
      imgSource = approved;
      break;
    case ApplicationStatusTypesEnum.INVITED:
      imgSource = approved;
      break;
    case programStatusTypes.ACTIVE:
      imgSource = approved;
      break;
    case eventStatusTypes.DENIED:
    case ApplicationStatusTypesEnum.Declined:
    case programStatusTypes.DECLINED:
    case BenefitStatusEnum.Expired:
    case accessControlUserStatusTypes.INACTIVE:
      imgSource = denied;
      break;
    case eventStatusTypes.SUBMITTED:
      imgSource = submitted;
      break;
    case eventStatusTypes.ONHOLD:
      imgSource = waiting;
      break;
    case ApplicationStatusTypesEnum.INVITED:
    case ApplicationStatusTypesEnum.REVIEW_ELIGIBLE:
      imgSource = waiting;
      break;
    case eventStatusTypes.SCHEDULED:
      imgSource = underReview;
      break;
    case ApplicationStatusTypesEnum.UNDER_REVIEW:
    case BenefitStatusEnum.Unclaimed:
      imgSource = underReview;
      break;
    case ApplicationStatusTypesEnum.SAVED:
    case programStatusTypes.INPROCESS:
      imgSource = saved;
      break;
    case VisualStudioBenefitStatusEnum.Assign:
      imgSource = approved;
      break;
    case VisualStudioBenefitStatusEnum.Remove:
      imgSource = denied;
      break;
    default:
      break;
  }
  return imgSource;
};

const StatusElement = ({ statusValue }: IStatusElementProps): React.ReactElement => {
  return (
    <>
      <StatusImg src={getImgSource(statusValue)} alt="" />
      <StatusSpan>{statusValue}</StatusSpan>
    </>
  );
};

export default StatusElement;
